export default "__VITE_ASSET__Dwrr4Avq__"